import page_routes from './pages';

const main_routes = [
 {
  path: '/', component: require('layouts/layout.vue').default,
  // meta: {
  //  requiresAuth: true,
  // },
  children: page_routes
 },
 {
  path: '/login', component: require('components/auth/login.vue').default,
  meta: {unauthenticated: true, title: 'Login'}
 },
 {
  path: '/register', component: require('components/auth/register.vue').default,
  meta: {unauthenticated: true, title: 'Register'}
 },
 {
  path: '/login_lock', component: require('components/auth/login_lock.vue').default,
  meta: {requiresAuth: true, unauthenticated: false, title: 'Locked'}
 },
 {
  path: '/logout', component: require('components/auth/logout.vue').default,
  meta: {requiresAuth: true, title: 'Logout'}
 },
 {
  path: '*', component: require('components/layouts/errors/error_404.vue').default,
  meta: {requiresAuth: true, title: 'Error 404'}
 },
];
export default main_routes;
